import * as Sentry from "@sentry/browser";

import { SENTRY_DSN } from "./config.js";
import { i18nPromise } from "./i18n";
import "../css/normalize.css";
import "../css/vendor-webflow.css";
import "../css/yenda.css";
import mainView from "./views/mainView";

/* eslint-disable */
Sentry.init({
  dsn: SENTRY_DSN,
  integrations: [
    // Send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,
});
/* eslint-enable */

// // import mainView from "./views/mainView.js";
// // import receiptView from "./views/receiptView.js";

// // Return array from object
// const imgBlockArray = Array.from(productView._imgBlock);

// // Get ID of all food items
// let idProductArray = imgBlockArray.map((el) => {
//   return Number(el.getAttribute("data-id"));
// });

// // Create a new array with non-null elements
// idProductArray = idProductArray.filter((el) => el);

// // Open food modal on image click
// export const controlProductOnClick = async function (event) {
//   // Get ID of food item
//   const id = event.target
//     .closest(".item-image-block")
//     .querySelector(".image-item")
//     .getAttribute("data-id");

//   if (id) {
//     event.preventDefault();
//     try {
//       // 1) Loading product
//       await model.loadProduct(id);

//       // 2) Render product info
//       productView.renderData(model.state.product);

//       // 3) Render modal with product image
//       productView.renderModal(model.state.product.imageUrl);

//       // 4) Render updated item price
//       productView.updateItemPrice();

//       cartView.handlerAddCart(controlAddCart);
//       productView.closeModalAddItem();
//       productView.closeBckgrndItem();
//     } catch (err) {
//       productView.renderError();
//     }
//   }
// };

// // Call init function as soon as the program starts
// const init = function () {
//   mainView.switchToggleAccount();
//   receiptView.closeModalReceipt();
//   receiptView.closeModalOnEscape();
// };

// init();

// Call init function as soon as the program starts
const init = function () {
  mainView.toggleMenu();
};

// Create an async function to start the application
const startApp = async () => {
  try {
    // Wait for i18next to be fully initialized
    await i18nPromise;

    // Now that translations are ready, run the main app logic
    init();
  } catch (error) {
    // Capture and send the error to Sentry
    Sentry.captureException(error);

    console.error("Failed to initialize the application:", error);
  }
};

// Start the application
startApp();
